export const environment = {
    production: true,
    BaseAPIUrl: "https://api-usermanagement.portugalmls.com/v1/",
    BaseAPIUrlTeamA: "https://api.portugalmls.com",
    BlobStorageBaseAPI: "https://media.portugalmls.com/smartrealestateimages",
    KnowledgeBaseAPI: "https://api-knowledgebase.portugalmls.com",
    GoogleTag: "GTM-55HFJJZ8",
    cookieDomain: 'syncmls.com'
};
